package link.erpango.quip.utils

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

actual object AppDispatchers {
    // JS logic runs in a single thread, so we map IO to Default (which is also Main/single threaded in JS browser context)
    // There is no Dispatchers.IO in Kotlin/JS browser target
    actual val IO: CoroutineDispatcher = Dispatchers.Default
    actual val Default: CoroutineDispatcher = Dispatchers.Default
    actual val Main: CoroutineDispatcher = Dispatchers.Main
}
